import { useTranslation } from "react-i18next";

import SessionHeader from "features/Session/SessionHeader";

import Button from "components/Button";
import Container from "components/Container";
import Footer from "components/Footer";
import { Form } from "components/Form";
import ProgressStatus from "components/ProgressStatus";

import PatientForm from "../PatientForm";

import { usePatientInformation } from "./usePatientInformation";

export default function PatientInformation() {
  const { t } = useTranslation();

  const { form, onSubmit } = usePatientInformation();

  const { handleSubmit } = form;

  return (
    <>
      <SessionHeader />
      <ProgressStatus />
      <Container>
        <Form {...form}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col justify-between px-4 md:px-0 pt-16 mb-20 md:mb-0"
            id="patient-information-form"
          >
            <PatientForm />
            <Footer className="md:justify-end">
              <Button className="w-full md:w-60" type="submit">
                {t("button.continue")}
              </Button>
            </Footer>
          </form>
        </Form>
      </Container>
    </>
  );
}
